import ResetPassword from '@/app/reset-password/ResetPassword'
import { createFileRoute } from '@tanstack/react-router'

const RouteComponent = () => {
  const { token } = Route.useSearch()
  return <ResetPassword token={token} />
}

export const Route = createFileRoute('/_unauth/reset-password')({
  component: RouteComponent,
})


